export default __webpack_public_path__ + "bc8ac44bb4b135202b26ee8d6d6fc2e3.png";